var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSslIcon = function SvgSslIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 28 35"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ssl-icon_svg__b",
    x1: "14.676%",
    x2: "80.501%",
    y1: "14.864%",
    y2: "76.57%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F8F8F9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "ssl-icon_svg__a",
    d: "M13 33s13-6.6 13-16.5V3.3L13 0 0 3.3v13.2C0 26.4 13 33 13 33Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#60BC57",
    fillOpacity: 0.34,
    xlinkHref: "#ssl-icon_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#ssl-icon_svg__b)",
    stroke: "#60BC57",
    strokeWidth: 2,
    xlinkHref: "#ssl-icon_svg__a"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 2,
    d: "m13 31.864.069-.039c.429-.24.909-.527 1.426-.855a33.95 33.95 0 0 0 4.34-3.255C22.706 24.277 25 20.49 25 16.5V4.078L13 1.032 1 4.078V16.5c0 3.991 2.294 7.777 6.164 11.215A33.95 33.95 0 0 0 13 31.864Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 33s13-6.6 13-16.5V3.3L13 0 0 3.3v13.2C0 26.4 13 33 13 33Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#61AD5A",
    strokeWidth: 2,
    d: "m17 12-4.375 7L10 16.429"
  }))));
};
export default SvgSslIcon;